import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './css/FormError.scss';

export default function FormError({
    children,
    className,
    ...props
}) {
    const classes = classNames(styles.error, className);
    return (
        <div {...props} className={classes}>
            {children}
        </div>
    );
}

FormError.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};
